// extracted by mini-css-extract-plugin
export default {"container":"BottomLead_container__djmZI","text":"BottomLead_text__aQom3"};